"use client";
import cn from "classnames";
import { usePathname } from "next/navigation";
import { type PropsWithChildren } from "react";
import Anchor, { type AnchorProps } from "@/components/common/Anchor";
import { useCreateInformaURL } from "@/hooks/useCreateInformaURL";

export type ActiveAnchorProps = AnchorProps;

export default function ActiveAnchor(
  props: PropsWithChildren<ActiveAnchorProps>,
) {
  const { href, children, extendedURI = true, ...restProps } = props;
  const { u } = useCreateInformaURL();
  const pathname = usePathname();
  const uri = extendedURI ? u(href.toString()) : href;

  const className = cn(props.className, {
    active: pathname === uri,
  });

  return (
    <Anchor href={uri} extendedURI={false} {...restProps} className={className}>
      {children}
    </Anchor>
  );
}
